import { db } from "../../../config/firebaseconfig"

const getAllEducators = (school,updateState) => {
  return new Promise ((resolve,reject) => {
    updateState({loadingEducators: true})
    return db.collection('educators').where('school', '==', school)
     .onSnapshot(querySnapshot => {
      let educators = []
      querySnapshot.forEach(doc => {
        if (doc.exists) {
          const data = doc.data()
          if (!data.deleted) educators.push(data)
        }
      })
      updateState({loadingEducators: false, educators})
      resolve(educators)
    },error => {
        
      updateState({
        loadingEducators: false,
        errorEducators: 'Educators were not fetched properly',
        educators: null,
      })
      reject(error);
      
     }); 
  })
}
export default getAllEducators;


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/getAllEducators.js